import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.BANNER_DYNAMIC

export function updateBannerSettings(data) {
    return apiHelper({ method: "post", path: pathBase.UPDATE, data })
}

export function getBannerSettings() {
    return apiHelper({ method: "get", path: pathBase.GET })
}
